import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, message } from 'antd';
import PreviewModal from '../../investigation/ViewInfoProcess';
import ExportUtil from '../../../common/ExportUtil';
import TableC from '../../basicElement/TableC';
import { ContractAttachment } from './Widget';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import SideNav from '../SideNav';
import Update from './Update';
import Filter from './Filter';
import { saveParams } from '../../../actions/noticeActions';
import fp from '../../../utils/fp';

class TerminationApply extends Component {
    constructor(props) {
        super(props);
        const { investigationId, investigationName } = props;
        const searchParams = {};
        if (investigationId) {
            searchParams.investigationId = investigationId;
            searchParams.investigation = {
                text: investigationName,
                value: investigationId,
            };
        }
        this.state = {
            loading: false,
            sortParams: {},
            searchParams,
            curParams: {...searchParams},
            pagination: {
                pageSize: 10,
                current: 1,
            },
            data: [],
            businessList: [],
            signingUnit: [],
        }
    }

    componentDidMount() {
        this.loadData();
        this.querySigningUnit();
        this.queryWithLevelByParams();
        this.queryDesignatePersonWithUser();
    }

    componentWillUnmount() {
        const { saveParams } = this.props;
        saveParams({ 
            investigationId: '',
            investigationName: '',    
        });
    }

    querySigningUnit = () => {
        dictCache.getDict('UNIT_SIGNING', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.contract.queryUnitOfSigningList,
                data: {
                    offset: 1,
                    limit: 999,
                },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { datas = [] } = res;
            this.setState({ signingUnit: datas });
        });
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    queryDesignatePersonWithUser = () => {
        const options = {
            method: 'POST',
            url: API_URL.user.queryDesignatePersonWithUser,
            data: {
                type:'ADD_JDE_APPLY',
            },
            dataType: 'json',
            doneResult: (res) => {
                this.setState({canAdd: res.isDesignatePerson})
            }
        }
        $.sendRequest(options)
    }

    loadData = () => {
        const { sortParams, searchParams, pagination, pagination: { current, pageSize } } = this.state;
        const params = this.splitParams(searchParams);

        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.contract.queryListByParams,
            data: {
                offset: current,
                limit: pageSize,
                ...params,
                ...sortParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [], totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    cancel = (invTerminationApplyId) => {
        Modal.confirm({
            title: '确认撤销该项目的终止申请?',
            onOk: () => {
                this.setState({ loading: true });
                const options = {
                    method: 'POST',
                    url: API_URL.proContract.cancelInvTerminationApply,
                    data: { invTerminationApplyId },
                    dataType: 'json',
                    doneResult: res => {
                        message.success(res.success);
                        this.setState({
                            loading: false,
                        }, () => {
                            this.loadData();
                        });
                    },
                    errorResult: () => {
                        this.setState({ loading: false });
                    }
                }
                $.sendRequest(options);
            }
        });
    }

    search = () => {
        const { pagination, curParams } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: {
                ...curParams,
            },
        }, () => {
            this.loadData();
        });
    }
    
    export = () => {
        const { sortParams, searchParams } = this.state;
        const params = this.splitParams(searchParams);
        const url = API_URL.contract.exportInvTerminationApplyList;
        ExportUtil.export({ ...sortParams, ...params }, null, url);
    }

    queryInvestigationStageByInvId = (investigationId, callback) => {
        // 点击触发的编辑权限门控查询：不缓存，保持实时（对齐 alterJdeCode/ApplyJdeCode/contractInfoChange 的处理）
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    loading: false,
                    invStageList: data,
                }, () => {
                    callback();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    jumpToApplyJdeCode = (jdeApplyCode) => {
        this.props.saveParams({ jdeApplyCode });
        location.href = './#/contractManagement/applyJdeCode';
    }

    getColumns = () => {
        const { curRole, userId } = sessionStorage;
        const isCSA = curRole === 'CSA';
        const isCSAL = curRole === 'CSAL';
        const isBAL = curRole === 'BAL';
        const isBA = curRole === 'BA';
        const columns =[{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            width: 60,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            fixed: 'left',
            width: 160,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 80,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineNames',
            key: 'secondLineNames',
            width: 80,
        }, {
            title: '项目阶段',
            dataIndex: 'stageName',
            key: 'stageName',
            width: 100,
            render: (text, record) => {
                const { invTerminationTime } = record;
                return text === '项目终止' ? <span>{text}<br />{invTerminationTime ? `(${invTerminationTime.slice(0, 10)})` : ''}</span> : text;
            },
        }, {
            title: '项目终止申请人',
            dataIndex: 'applyUserName',
            key: 'applyUserName',
            width: 120,
            render: (text, record) => {
                const { applyUserCode } = record;
                return text ? `${text}[${applyUserCode}]` : '';
            },
        }, {
            title: '申请发起时间',
            dataIndex: 'applyInitiateTime',
            key: 'applyInitiateTime',
            sorter: true,
            width: 120,
            render: text => text ? text.slice(0, 10) : '',
        }, {
            title: '申请项目终止时间',
            dataIndex: 'terminationTime',
            key: 'terminationTime',
            width: 120,
            render: text => text ? text.slice(0, 10) : '',
        }, 
        {
            title: '项目终止情况',
            dataIndex: 'investigationPauseInfo',
            key: 'investigationPauseInfo',
            width: 160,
        },{
            title: '项目终止原因',
            dataIndex: 'investigationPauseReason',
            key: 'investigationPauseReason',
            width: 160,
        }, {
            title: 'JDE建号申请人',
            dataIndex: 'jdeApplyUserName',
            key: 'jdeApplyUserName',
            width: 120,
            render: (text, record) => {
                const { jdeApplyUserCode } = record;
                return text ? `${text}[${jdeApplyUserCode}]` : '';
            },
        }, {
            title: 'JDE建号申请编号',
            dataIndex: 'jdeApplyCode',
            key: 'jdeApplyCode',
            width: 120,
            render: (text, record) => {
                const { jdeApplyCode } = record;
                return <a onClick={() => this.jumpToApplyJdeCode(jdeApplyCode)}>{text}</a>
            }
        }, {
            title: 'JDE建号申请状态',
            dataIndex: 'jdeApplyStatusShow',
            key: 'jdeApplyStatusShow',
            width: 120,
        }, {
            title: '合同开始时间',
            dataIndex: 'contractStartDate',
            key: 'contractStartDate',
            sorter: true,
            width: 120,
            render: text => text ? text.slice(0, 10) : '',
        }, {
            title: '合同结束时间',
            dataIndex: 'contractEndDate',
            key: 'contractEndDate',
            sorter: true,
            width: 120,
            render: text => text ? text.slice(0, 10) : '',
        }, {
            title: '津石计划负责中心数量',
            dataIndex: 'typeSiteAmount',
            key: 'typeSiteAmount',
            width: 80,
        }, {
            title: '津石计划筛选数量',
            dataIndex: 'typeFilterAmount',
            key: 'typeFilterAmount',
            width: 80,
        }, {
            title: '津石计划随机(入组)数量',
            dataIndex: 'typeRandomAmount',
            key: 'typeRandomAmount',
            width: 100,
        }, {
            title: '实际启动中心数',
            dataIndex: 'startSiteNum',
            key: 'startSiteNum',
            width: 80,
        }, {
            title: '累计筛选数',
            dataIndex: 'totalFilterAmount',
            key: 'totalFilterAmount',
            width: 80,
        }, {
            title: '累计随机(入组)数',
            dataIndex: 'totalRandomAmount',
            key: 'totalRandomAmount',
            width: 80,
        }, {
            title: '项目当月累计完工百分比',
            dataIndex: 'cumulativeFinishPercent',
            key: 'cumulativeFinishPercent',
            width: 100,
        }]
        if( !isBA ) {
            columns.push({
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                fixed: 'right',
                width: 160,
                render: (text, record, index) => {
                    const { curRole } = sessionStorage;
                    const { canAdd = false } = this.state;
                    const isRole = fp.contains(curRole)
                    const { jdeApplyStatusShow, investigationId, invTerminationApplyId } = record;
                    const comDom = (
                        <span>
                            <a onClick={() => this.showContractAttachment(record)}>查看附件</a>
                            <span className="ant-divider" />
                            <a onClick={() => this.showPreviewModal(investigationId)}>查看项目信息和进展</a>
                        </span>
                    );
                    if (canAdd) {
                        return (
                            <span>
                                {
                                    jdeApplyStatusShow === '未申请' &&
                                    <span>
                                        <a onClick={() => this.queryInvestigationStageByInvId(investigationId, () => this.update(record))}>添加JDE建号申请</a>
                                        <span className="ant-divider" />
                                    </span>
                                }
                                {comDom}
                            </span>
                        );
                    } else if (curRole === 'PM') {
                        return (
                            <span>
                                {
                                    jdeApplyStatusShow === '未申请' &&
                                    <span>
                                        <a onClick={() => this.cancel(invTerminationApplyId)}>撤销项目终止申请</a>
                                        <span className="ant-divider" />
                                    </span>
                                }
                                {comDom}
                            </span>
                        );
                    }
                    return comDom;
                }
            })
        }
        return columns
    }

    

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    handleFilterChange = (curParams) => {
        this.setState({ curParams });
    }

    update = (record) => {
        this.updateRef.show(record);
    }

    showContractAttachment = (record) => {
        this.contractAttachmentRef.show(record);
    }

    showPreviewModal = investigationId => {
        this.previewModalRef.show(investigationId);
    }

    render() {
        const { data, loading, sortParams, curParams, pagination, businessList, signingUnit } = this.state;
        return (
            <div className="content">
                <SideNav selectKey='terminationApply' />
                <div className="main">
                    <Filter
                        search={this.search}
                        params={curParams}
                        businessList={businessList}
                        onChange={this.handleFilterChange}
                        buttons={[
                            <Button key="export" type="primary" onClick={this.export}>导出</Button>,
                        ]}
                    />
                    <TableC
                        data={data}
                        scrollY={550}
                        loading={loading}
                        sortParams={sortParams}
                        columns={this.getColumns()}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                    />
                    <ContractAttachment ref={el => this.contractAttachmentRef = el} />
                    <Update
                        ref={el => this.updateRef = el}
                        loadData={this.loadData}
                        signingUnitList={signingUnit}
                    />
                    <PreviewModal isModal={true} canEdit={false} loadData={this.loadData} ref={el => this.previewModalRef = el} />
                </div>           
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        ...state.noticeState.params,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TerminationApply);


// WEBPACK FOOTER //
// ./src/components/contractManagement/terminationApply/index.js